var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.942,
    height: 25.072,
    viewBox: "0 0 30.942 25.072",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_166",
    "data-name": "\\u30D1\\u30B9 166",
    d: "M-164.8,237.016v25.072h30.942V237.016Zm15.61,11.991-.123.1-13.029-10.087h13.152Zm-13.61,11.081v-18.9l13.487,10.441,13.455-10.417v18.873Z",
    transform: "translate(164.803 -237.016)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.93ac5caeef7d095c05f9f4f8ebbddda6.svg";
export { ForwardRef as ReactComponent };